var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,_vm._b({tag:"component",class:[_vm.sizeClass],on:{"click":function($event){_vm.el === 'button' ? _vm.$emit('click') : null}}},'component',Object.assign({}, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }